import { EventEmitter } from "@angular/core";
import { QuestionChoice } from "app/client/section/QuestionChoice";
import { ClientsService } from "app/services/client/ClientsService";

export class Section  {

    sectionLoadedEvent = new EventEmitter<any>();

    sigleChoice: boolean; 
    showIcons: boolean;
    displayMode: number = 1;
    questions: any[] = [];
    choices: string[] = [];
    sectionId: number;
    currentQuestion: number = 0;
    assessmentId: number;

    questionsChoices: QuestionChoice[] = [];
    questionsIds: number[] = [];

    constructor(
        sectionId: number,
        assessmentId: number,
        sigleChoice: boolean, 
        showIcons: boolean,
        displayMode: number,
        private _ClientsService: ClientsService
    )
    {
        this.sectionId = sectionId;
        this.assessmentId = assessmentId;
        this.sigleChoice = sigleChoice ;
        this.showIcons = showIcons;
        this.displayMode = displayMode;
    }

    load() {

        //getAssessmentSectionQuestions
        this._ClientsService.getAssessmentSectionQuestions(this.assessmentId, this.sectionId)
            .subscribe(res => {
                this.questions = res.result;
                

                if (this.sigleChoice) {
                    //getSectionChoices
                    console.log('!!!!!!!!!!!!!!!!!SECTION CLASS!!!!!!!!!!!!!!!!!!  getSectionChoices');
                    this._ClientsService.getAssessmentSectionChoices(this.sectionId, "EN") 
                        .subscribe(res => {
                            this.choices = res.result;

                            this.sectionLoadedEvent.emit();
                        });
                }
                else {
                    //getQuestionChoices
                  /*  this.getQuestionChoices.getQuestionChoices(this.currentQuestion)
                        .subscribe(res => {
                            this.choices = res.result;
                            this.show(this.questions, this.choices, this.showIcons);
                        });*/
                    for (var i = 0; i < res.result.length; i++){
                        this.questionsIds.push(res.result[i].Id);
                    }
                    

                    this.loadQuestions();
                   // this.sectionLoadedEvent.emit();
                }
            });

    }

    loadQuestions() {
        let questionsChoices: QuestionChoice;
        console.log('loadQuestions');

        questionsChoices = new QuestionChoice(this._ClientsService, this.questionsIds[this.currentQuestion]);
        questionsChoices.questionLoadedEvent.subscribe((data: any) => {
                this.questionLoaded();
        });

        this.questionsChoices.push(questionsChoices);

        questionsChoices.loadQuestionsChoices();
    }

    questionLoaded() {

        this.currentQuestion++;

        if (this.currentQuestion < this.questions.length)
        {
            this.nextQuestion();
        }
        else {
            console.log('all questions loaded');
            this.sectionLoadedEvent.emit();
        }

    }

    nextQuestion() {
        this.loadQuestions();
    }

    

}
